import { Link } from 'react-router-dom';
import { homepageArticleCards } from '@/mocks/articles';

export default function ArticleSection() {
  const articles = homepageArticleCards;

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12 md:mb-16">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full border border-background-300/60 bg-background-100 text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-5 whitespace-nowrap">
              Knowledge Base
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold font-heading text-foreground-950 leading-tight">
              GTBuy Sheet Guides
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-500 max-w-md">
            In-depth articles and tutorials to help you master GTBuy Spreadsheet and grow your reselling business — {articles.length} guides and counting.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group block bg-white rounded-2xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt || article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 right-3 px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-semibold text-primary-600 whitespace-nowrap">
                  {article.category}
                </span>
              </div>

              <div className="p-5">
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors duration-300 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-2 text-sm font-semibold text-primary-500">
                  <span className="whitespace-nowrap">Read Article</span>
                  <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}